<template>
  <div class="todo-node" :class="{ 'todo-node--checked': checked }">
    <v-checkbox
      :input-value="checked"
      :label="text"
      hide-details
      class="todo-node__checkbox"
      @change="onCheckChange"
    />
  </div>
</template>

<script>
export default {
  name: 'TodoNode',
  props: {
    nodeId: String,
    editMode: Boolean,
    text: {
      type: String,
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCheckChange(value) {
      this.$emit('update:props', { checked: value });
    },
  },
};
</script>

<style lang="less">
.todo-node {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid whitesmoke;
  transition: background-color 0.2s ease;

  &--checked {
    background-color: #f5f5f5;

    .todo-node__checkbox .v-label {
      text-decoration: line-through;
      color: rgba(0, 0, 0, 0.5);
    }
  }

  &__checkbox {
    margin: 0;
    padding: 0;

    .v-input__slot {
      margin: 0;
    }
  }
}
</style>
